import { FC } from 'react';

export const LandingPage: FC = () => {
  const styles = {
    banner: {
      container: 'flex flex-col items-center justify-center bg-white',
      title: 'text-4xl font-bold mb-4',
    },
    hero: {
      container: 'flex flex-col items-center justify-center py-[24px] gap-8 bg-black',
      number: 'w-full text-[180px] text-center font-extrabold text-white',
      subtitle: 'text-center font-bold text-white w-full text-[24px]',
    },
    registration: {
      container: 'flex flex-col items-center justify-center py-6 px-4 bg-white text-center gap-4',
      title: 'text-2xl font-bold',
      phone: 'text-3xl font-bold',
      subCopy: 'text-base',
      onlineCopy: 'text-base underline',
    },
    benefits: {},
    footer: {},
  };

  const shieldIcon = (
    <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3594 2.16797L2.98828 6.5625C2.34375 6.79688 1.875 7.44141 1.93359 8.14453C1.93359 13.6523 4.21875 23.3789 13.3594 27.7734C13.8281 28.0078 14.3555 28.0078 14.8242 27.7734C23.9648 23.3789 26.25 13.6523 26.3086 8.14453C26.3086 7.44141 25.8398 6.85547 25.1953 6.5625L14.8242 2.16797C14.3555 1.93359 13.8281 1.93359 13.3594 2.16797ZM15.5859 0.410156L25.8984 4.80469C27.1875 5.39062 28.1836 6.62109 28.1836 8.14453C28.125 14.0039 25.7227 24.6094 15.6445 29.4727C14.6484 29.9414 13.5352 29.9414 12.5391 29.4727C2.46094 24.6094 0.0585938 14.0039 0.0585938 8.14453C0 6.62109 0.996094 5.39062 2.28516 4.80469L12.6562 0.410156C13.5938 0 14.6484 0 15.5859 0.410156ZM20.3906 11.8945L12.8906 19.3945C12.5391 19.7461 11.8945 19.7461 11.543 19.3945L7.79297 15.6445C7.44141 15.293 7.44141 14.6484 7.79297 14.2969C8.14453 13.9453 8.78906 13.9453 9.14062 14.2969L12.2461 17.4023L19.043 10.5469C19.3945 10.1953 20.0391 10.1953 20.3906 10.5469C20.7422 10.8984 20.7422 11.543 20.3906 11.8945Z"
        fill="black"
      />
    </svg>
  );

  return (
    <>
      <div id="banner-title" className={styles.banner.container}>
        <h1 className="py-3 px-5 bg-gray-500 w-full text-center text-white font-bold">
          Activate now for FREE*
        </h1>
      </div>
      <div id="hero" className={styles.hero.container}>
        <p className={styles.hero.number}>10</p>
        <h3 className={styles.hero.subtitle}>Year Parts Guarantee</h3>
      </div>
      <div id="hero-copy" className={styles.banner.container}>
        <p className="text-center text-balance pt-3 pb-0 px-5 bg-gray-500 w-full text-white">
          Your new appliance comes with a 2-year manufacturer’s guarantee.
        </p>
        <p className="text-center text-balance pt-0 pb-3 px-5 bg-gray-500 w-full text-white">
          By registering your appliance, you will receive an additional 8-year parts guarantee –
          free* of charge.
        </p>
      </div>
      <div id="registration" className={styles.registration.container}>
        <div id="title" className={styles.registration.title}>
          Call now and activate**
        </div>
        <div id="phone">
          <a href="tel:0800 123 4567" className={styles.registration.phone}>
            0800 123 4567
          </a>
        </div>
        <div id="sub-copy" className={styles.registration.subCopy}>
          Activation by phone is quick and provides additional information about your manufacturer's
          and 10-year parts guarantee. Lines are open Monday to Friday 8am-8pm, Saturday 8am-6pm and
          Sunday 9am-6pm.
        </div>
        <div id="online-copy" className={styles.registration.onlineCopy}>
          Alternatively, you can register online. Click here.
        </div>
      </div>
      <div id="registration-benefits" className={styles.banner.container}>
        <div id="title" className="text-2xl font-bold py-4">
          Activate your free guarantee today to:
        </div>
        <ul className="list-disc list-inside text-balance pb-4 px-5 flex">
          <li className="flex flex-col items-center">
            {shieldIcon}
            <span className="mt-2 text-center">Gain an additional 8-year parts guarantee</span>
          </li>
          <li className="flex flex-col items-center">
            {shieldIcon}
            <span className="mt-2 text-center">Record your proof of purchase date</span>
          </li>
          <li className="flex flex-col items-center">
            {shieldIcon}
            <span className="mt-2 text-center">
              Learn about important appliance and safety updates
            </span>
          </li>
          <li className="flex flex-col items-center">
            {shieldIcon}
            <span className="mt-2 text-center">
              Get easy access to Haier-approved repair services
            </span>
          </li>
        </ul>
      </div>
      <div id="footer" className={styles.banner.container}>
        <div>
          <ul>
            <li>Website terms of use</li>
            <li>Privacy Notice</li>
            <li>Cookie Notice</li>
          </ul>
        </div>
        <div className="flex flex-col py-10 gap-3 bg-gray-100 w-full text-center text-balance">
          <p>
            * By registering your appliance, you will activate your FREE 10-year parts guarantee
            (inclusive of your legal guarantee period). If not activated proof of purchase needed.
            Labour charges and other conditions apply. For T&C’s, visit
            www.haier-europe.com/en_GB/pages/terms-conditions-extended-warranty.
          </p>
          <p>
            ** Haier has appointed Domestic & General Insurance PLC to provide product registration
            services and insurance policies to accompany its products. At Domestic & General, we
            treat your data with care. You can relax knowing it’s completely secure and only ever
            used responsibly. To find out more about how we use your information, scan the QR code
            or head to https://www.domesticandgeneral.com/mydata/haier
          </p>
          <p>
            Haier is a trading name of Haier Smart Home UK & I Ltd. Registered in England and Wales.
            Company no. 02521528 with its registered office at 302 Bridgewater Place, Birchwood
            Park, Birchwood, Warrington WA3 6XG
          </p>
          <p>
            Service plans and maintenance & support plans are provided by Domestic & General
            Services Limited. Company No. 1970780. Insurance policies are provided by Domestic &
            General Insurance PLC. Company No. 485850. Registered Office for both companies: Swan
            Court, 11 Worple Road, Wimbledon, London SW19 4JS. Both companies are registered in
            England and Wales. Domestic & General Insurance PLC is not an insurance intermediary.
            We’re the underwriter of the insurance policies and don’t provide personal
            recommendations or advice.
          </p>
          <p>
            Domestic & General Insurance PLC is authorised by the Prudential Regulation Authority
            and regulated by the Financial Conduct Authority and the Prudential Regulation
            Authority. Financial register number 202111.
          </p>
          <p>
            Domestic & General Insurance PLC is an insurance undertaking, not an intermediary. We
            are the underwriter of the insurance and do not provide a personal recommendation or
            advice. Domestic & General Insurance PLC pay their sales agents periodic incentives
            (such as bonus payments) if they meet certain quality and sales targets. All prices
            include all applicable taxes (including IPT). ©
          </p>
          <p>{new Date().getFullYear()} Domestic & General Group Limited. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};
